var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-delete": false,
          "show-save": false,
          "show-cancel": false,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _c("vehicle-list-side-menu", {
              on: { filter: _vm.filterList, reset: _vm.resetList },
              model: {
                value: _vm.filter,
                callback: function ($$v) {
                  _vm.filter = $$v
                },
                expression: "filter",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "tile is-parent" }, [
            _c(
              "article",
              { staticClass: "tile is-child box" },
              [
                _c(
                  "bulma-table",
                  {
                    staticClass:
                      "table is-bordered is-striped is-narrow is-fullwidth",
                    attrs: {
                      columns: _vm.columns,
                      "page-index": _vm.filter.pageIndex,
                      "page-size": _vm.filter.pageSize,
                      "total-rows": _vm.totalRows,
                      "is-loading": _vm.isTableLoading,
                      "sort-column": _vm.filter.sortColumn,
                      "sort-order": _vm.filter.sortOrder,
                    },
                    on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                  },
                  [
                    _vm._l(_vm.entitySummaries, function (c, idx) {
                      return _c(
                        "tr",
                        {
                          key: c.id,
                          class: { "is-selected": _vm.selectedRow === idx },
                          on: {
                            click: function ($event) {
                              return _vm.highlightSelected(idx, $event)
                            },
                          },
                        },
                        [
                          _c(
                            "td",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: { path: c.vehicleID },
                                    append: "",
                                  },
                                },
                                [_vm._v(" " + _vm._s(c.rego) + " ")]
                              ),
                            ],
                            1
                          ),
                          _c("td", [
                            _vm._v(
                              _vm._s(`${c.make.trim()} ${c.model.trim()}`)
                            ),
                          ]),
                          _c("td", [_vm._v(_vm._s(c.customerName))]),
                          _c("td", [
                            c.buildMonth && c.buildYear
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$filters.pad(c.buildMonth, 2)) +
                                      "/" +
                                      _vm._s(c.buildYear)
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _c("td", [_vm._v(_vm._s(c.bodyStyle))]),
                          _c("td", { staticClass: "has-text-centered" }, [
                            _vm._v(_vm._s(c.paintGroup)),
                          ]),
                          _c("td", { staticClass: "has-text-centered" }, [
                            _vm._v(_vm._s(c.transmissionType)),
                          ]),
                          _c("td", { staticClass: "has-text-centered" }, [
                            _c(
                              "span",
                              {
                                staticClass: "icon",
                                class: [
                                  c.active
                                    ? "has-text-success"
                                    : "has-text-danger",
                                ],
                              },
                              [
                                _c("i", {
                                  staticClass: "mdi mdi-24px",
                                  class: [c.active ? "mdi-check" : "mdi-close"],
                                }),
                              ]
                            ),
                          ]),
                          _c(
                            "td",
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "button is-primary is-small is-inverted",
                                  attrs: {
                                    to: { path: c.vehicleID },
                                    append: "",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "icon is-medium" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "mdi mdi-lead-pencil mdi-24px",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    _c("template", { slot: "empty" }, [
                      _c("section", { staticClass: "section" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "content has-text-grey has-text-centered",
                          },
                          [
                            _c("span", { attrs: { icon: "icon is-large" } }, [
                              _c("i", {
                                staticClass: "mdi mdi-48px mdi-emoticon-sad",
                              }),
                            ]),
                            _c("p", [_vm._v("Nothing")]),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }